import React from "react";

export default props => (
  <header>
    {props.children}
  </header>
);



// WEBPACK FOOTER //
// ./src/components/Header.js